// ds-color-ignore-file: system font stack in dev/internal file
"use client"

import { useState } from "react"
import { FeedbackToolbar } from "@ahead-health/core/ui/feedbackToolbar"
import { Cockpit } from "@/components/editor/cockpit"
import { DevEditorSwitcher } from "@/components/editor/dev-editor-switcher"

export function MarketingSiteFeedbackToolbar() {
  // Edit mode on by default once signed in — it's the most-used action.
  const [editing, setEditing] = useState(true)
  // Deep-link entry from the "Translation review" CI status, whose target_url is
  // <preview>/ch/en?review-cockpit=1&pr=<n>. When a reviewer lands here without a
  // live SSO session on this origin, `autoOpen` makes the toolbar pop its sign-in
  // panel immediately (instead of the easy-to-miss FAB), then closes it once
  // signed in — so the cockpit's Review tab (pre-selected by the same param in
  // <Cockpit>'s initialTab()) is the only surface. Browsers block a true zero-
  // click SSO popup (no user gesture), so a one-click prompt is the floor here.
  // Read once on mount; matches the param check in cockpit.tsx's initialTab().
  const [autoOpen] = useState(() => {
    if (typeof window === "undefined") return false
    const params = new URLSearchParams(window.location.search)
    return params.has("review-cockpit") || params.has("review")
  })
  return (
    <>
      <FeedbackToolbar
        packageName="marketing-site"
        commitSha={process.env.NEXT_PUBLIC_AHEAD_COMMIT_SHA}
        branch={process.env.NEXT_PUBLIC_AHEAD_BRANCH}
        autoOpen={autoOpen}
        // Fold the feedback popup into the cockpit's bottom slot (instead of the
        // fixed bottom-right popup) so it no longer overlaps the docked cockpit.
        getPanelContainer={() =>
          typeof document !== "undefined"
            ? document.querySelector<HTMLElement>(
                "[data-ahead-embedded-feedback]"
              )
            : null
        }
        editMode={{
          label: "Edit content",
          active: editing,
          onToggle: () => setEditing((v) => !v),
          render: (identity) => (
            <Cockpit
              active={editing}
              identity={{
                idToken: identity.idToken,
                environment: identity.environment,
                branch: identity.branch,
              }}
              // Leave edit mode from inside the cockpit head, so the only exit
              // isn't buried in the ahead-core FAB's "editing…" toggle.
              onExit={() => setEditing(false)}
            />
          ),
        }}
      />
      {/* Dev-only "use it as <account>" path — renders nothing unless
          NEXT_PUBLIC_DEV_EDITOR_IMPERSONATION=true on a local build. */}
      <DevEditorSwitcher />
    </>
  )
}
